import React, { memo } from 'react';
import ReactPlayer from 'react-player';

import palette from '@lib/core/src/theme/palette';
import { Box, styled } from '@mui/material';

const PlayerWrapper = styled(Box)({
  width: '100%',
  height: '100%',
  borderRadius: '12px',
  overflow: 'hidden',
  backgroundColor: palette.black,
  position: 'relative',
  '& video': {
    display: 'block',
    width: '100%',
    height: '100%',
    objectFit: 'contain'
  }
});

type PlayerProps = {
  recordingUrl: string;
  reactPlayerRef: React.RefObject<ReactPlayer>;
  onVideoProgress: (playedSeconds: number) => void;
  onVideoReady: () => void;
  width?: string | number;
  height?: string | number;
  playing?: boolean;
  style?: React.CSSProperties;
};

const Player = ({
  recordingUrl,
  reactPlayerRef,
  onVideoProgress,
  onVideoReady,
  playing,
  style
}: PlayerProps) => (
  <PlayerWrapper style={style}>
    <ReactPlayer
      url={recordingUrl}
      controls
      pip={true}
      playing={playing}
      stopOnUnmount={false}
      ref={reactPlayerRef}
      onProgress={progress => {
        onVideoProgress(progress.playedSeconds);
      }}
      progressInterval={500}
      onReady={() => {
        onVideoReady();
      }}
      width={'100%'}
      height={'100%'}
      playsinline={true}
    />
  </PlayerWrapper>
);

export default memo(Player);
